
export const onLogout = (state) => {
    // state.token = null
    // state.user = null
}

export const supplier = (state, supplier)=>{
    console.log('supp', supplier)
    state.supplier = supplier
}